



































import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ContextsState } from '@/store';
import DataSource from 'devextreme/data/data_source';
import { Table, TableOptions, removeItemsFromView, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import {
    DxDataGrid
} from 'devextreme-vue/data-grid';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract,
    EventsServiceContract,
    Events
} from '@/core/contracts';
import { lookupField, guid } from '@/core/helpers';
import { Channel, Channels, Site, Cost } from '@/dto';
import { IContext } from '@/api/dto';
import ChannelsListTable from './ChannelsListTable.vue';
import DevExpress from 'devextreme/bundles/dx.all';

@Component({
    components: {
        DxDataGrid,
        ChannelsListTable,
        TableOptions
    }
})
export default class ChannelsListPage extends Page {
    public table: Table | null = null;
    public tableKey: string = 'channels-control';
    public sites: Site[] = [];
    private resourceTypes: any[] | undefined = [];

    @Inject(CONTRACTS.WindowsService) private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService) private _eventsService?: EventsServiceContract;

    private maximalArgument: number = 1;
    private minimalArgument: number = 0;
    private  minimalValue: number = 0;

    public setTable(table: Table): void {
        this.table = table;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof Channel,
            load: this.load,
            insert: (channel: Channel) => this.insert(channel),
            update: (id: string, data: Channel) => this.update(id, data)
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public get sitesList(): Site[] {
        return this.sites;
    }

    public get isRowSelected() {
        return this.table && this.table!.getSelectedRowKeys().length === 1;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public addChannel() {
        this.table!.addRow();
    }

    public editChannel() {
        const selectedKey = this.table!.getSelectedRowKeys()[0];

        if (selectedKey) {
            const selectedIndex = this.table!.getRowIndexByKey(selectedKey);
            this.table!.editRow(selectedIndex);
        }
    }

    private deleteChannel() {
        const table = this.$refs['table-component']  as ChannelsListTable;
        table.deleteChannel();
    }

    private async load() {
        const currentContextId = ContextsState.currentContextId;
        const sitesUrl = `/files/contexts/${currentContextId}/Sites`;
        const channelsUrl = `/files/contexts/${currentContextId}/Channels`;
        const resourceTypesUrl = `/files/contexts/${currentContextId}/ResourceTypes`;
        const resourceTypesData = await this
            ._fetchService!.get<IContext>(`/files/contexts/${currentContextId}/ResourceTypes`);
        this.resourceTypes = resourceTypesData.resourceTypes as any;
        const sitesData =  await this._fetchService!.get<IContext>(sitesUrl);
        this.sites = sitesData.sites as Site[];
        const channelsData = await this._fetchService!.get<IContext>(channelsUrl);
        return this.transformData(channelsData);
    }

    private transformData(data: IContext): Channel[] {
        if (!(data && data.channels)) {
            return [];
        }
        for (const item of data.channels as Channel[]) {
            item.source = this.sites!.find(s => s.id === item.sourceId) as Site;
            item.destination = this.sites!.find(s => s.id === item.destinationId) as Site;
        }

        return data.channels as Channel[];
    }

    private async insert(channel: Channel) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        if (channel.transportationCost) {
            channel.transportationCost = this.setCost(channel.transportationCost);
        }
        const data = {
            Channels_Partial: [channel]
        };
        return await this._fetchService!.post<Channel>(url, JSON.stringify(data));
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async update(id: string, channel: Channel) {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        channel.id = id;
        if (channel.transportationCost) {
            channel.transportationCost = this.setCost(channel.transportationCost);
        }
        const data = {
            Channels_Partial: [channel]
        };
        return await this._fetchService!.post<Channel>(url, JSON.stringify(data));
    }

    private setCost(cost: any): Cost[] {
        return [{
            maximalArgument: this.maximalArgument,
            maximalValue: cost,
            minimalArgument: this.minimalArgument,
            minimalValue: this.minimalValue
        }];
    }
}
